var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamionRecogidaNocar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #343434;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M362.7,394.7c0,17.7,14.3,32,32,32s32-14.3,32-32v-10.7h-64v10.7Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M487.7,28.3c-7.5-7.4-19.5-7.4-26.9,0l-89.5,89.5-20.6-29.5c-20-28.6-52.6-45.6-87.5-45.6h-7.1c-35.3,0-64,28.7-64,64v106.7h-106.7c-47.2,0-85.4,38.1-85.4,85.3v42.7c0,23.6,19.1,42.7,42.7,42.7v10.7c0,14.7,4.3,28.4,11.6,40l-26,26c-7.4,7.5-7.4,19.5,0,26.9s8.5,5.6,13.4,5.6h0c4.8,0,9.7-1.9,13.4-5.6L487.7,55.2c7.4-7.4,7.5-19.5,0-26.9ZM234.8,106.6c0-11.8,9.6-21.3,21.3-21.3h7.1c21,0,40.6,10.2,52.6,27.4l24.9,35.7-64.9,64.9h-41v-106.7ZM42.7,298.7c0-23.6,19.1-42.7,42.7-42.7h147.7l-85.4,85.4H42.7v-42.7ZM85.3,394.8h0v-10.8h19.8l-18.8,18.8c-.7-2.6-1-5.2-1-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M438.6,214h-.2c0,0-38.8-55.6-38.8-55.6l-30.6,30.6,16.9,24.2h-41.1l-42.7,42.7h124.7c23.6,0,42.7,19.1,42.7,42.7v42.7h-252.7l-123.9,123.9c7.7,2.7,15.9,4.1,24.5,4.1,41.2,0,74.7-33.4,74.7-74.7v-10.7h128v10.7c0,41.2,33.4,74.7,74.7,74.7s74.7-33.4,74.7-74.7v-10.7c23.6,0,42.7-19.1,42.7-42.7v-42.7c0-42.6-31.4-78.7-73.6-84.5ZM426.7,394.7c0,17.7-14.3,32-32,32s-32-14.3-32-32v-10.7h64v10.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamionRecogidaNocar);
export default __webpack_public_path__ + "static/media/camion-recogida_nocar.359677e079f4a4a06e37991731ee99e6.svg";
export { ForwardRef as ReactComponent };